import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { getOrderStatus, logOpenpayCallbackResponse, saveOpenpayPlanAndCheckout } from "../actions/openpayActions";
import { checkout } from "../actions/checkoutActions";
import { withTranslation } from 'react-i18next';
import queryString from 'query-string';
import { withRouter } from "react-router";
import { showSuccess, showInfo } from "../common/iziToast";
import * as Icons from "../common/icons";
import { Redirect } from "react-router-dom";
import { OpenpayCheckoutStatusEnum } from '../common/enums';
import Alert from "../components/Alert";
import ConfirmDialog from "../components/ConfirmDialog";


class OpenpayCheckout extends Component {
    state = { orderId: 0, isCancelled: false, hasErrored: false, planAlreadySubmitted: false };

    componentDidMount() {
        const { user, openpayPlan } = this.props;
        window.onbeforeunload = (event) => {
            const e = event || window.event;
            // Cancel the event
            e.preventDefault();
            if (e) {
                e.returnValue = ''; // Legacy method for cross browser support
            }
            return ''; // Legacy method for cross browser support
        };

        if (openpayPlan && openpayPlan.id && this.state.planAlreadySubmitted === false) // Page refreshed don't submit the order again
            return;

      
        if (user.isAuthenticated) {
            const value = queryString.parse(this.props.location.search, { parseBooleans: true });
            try {
                const logInfo = { 'loggerId': user.id, 'data': JSON.stringify(value), 'for': 'openpay' };
                this.props.logOpenpayCallbackResponse(logInfo).then((response) => { }, (error) => {});
            } catch (e) { }

            if (value && value.status === OpenpayCheckoutStatusEnum.Cancelled) {
                this.setState({ isCancelled: true });
                return;
            }
            if (value && (value.status === OpenpayCheckoutStatusEnum.Failure || value.status === OpenpayCheckoutStatusEnum.Errored || value.status === OpenpayCheckoutStatusEnum.Refused)) {
                this.setState({ hasErrored: true });
                return;
            }
            if (value && value.planid) {
                this.setState({ planAlreadySubmitted: true }, this.props.saveOpenpayPlanAndCheckout({ id: value.planid, status: value.status }));
            }
        }
       
    }

    render() {

        const { t, settings, orderResponse, user, openpayPlan, error } = this.props;

        if (!user.isAuthenticated) {
            return <ConfirmDialog open={true} title={t("Checkout")} message={t("You must login before checkout.")}
                yesTitle={t("Login/Register")} onYes={() => this.props.history.push(`${settings.baseUrl}login`)} noTitle={t("Go Back")} onNo={() => this.props.history.go(-2)} />;
        }

        if (this.state.hasErrored === true) {
            return <Alert type="danger" title={t("Checkout")} msg={t("Unable to process your payment using Openpay. please try again later")} />;
        }

        if (this.state.isCancelled === true) {
            showInfo(t("Checkout"), t("Your chose to cancel payment using Openpay"), Icons.CART);
            return <Redirect to={`${settings.baseUrl}`} />;
        }

        if (error && error.id != null && error.moduleCode === 23) {
            return <Redirect to={`${settings.baseUrl}`} />;
        }

        if (orderResponse.newOrderId > 0) {
            showSuccess(t("Checkout"), t("Your order has been submitted"), Icons.CART);
            return <Redirect to={`${settings.baseUrl}checkout-complete`} />;
        }

        if (openpayPlan && openpayPlan.id && this.state.planAlreadySubmitted === false) {
            return <Redirect to={`${settings.baseUrl}checkout-complete/refreshed`} />;
        }


        return (
            <div className="card text-center">
                <div className="card-body padding-top-2x">
                    <h3 className="card-title">{t("Please wait, Your order is being processed!")}</h3>
                    <p className="card-text" > {t("Please do not refresh or close your browser while we process your order.")}</p>
                </div>
            </div>
        );
    }
}

function mapStateToProps({ settings, checkoutSale, orderResponse, user, openpayPlan, error }, ownProps) {
    return { settings, checkoutSale, orderResponse, user, openpayPlan, error, ...ownProps };
}


export default withRouter(withTranslation()(connect(mapStateToProps, { getOrderStatus, checkout, logOpenpayCallbackResponse, saveOpenpayPlanAndCheckout })(OpenpayCheckout)));